var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-privacy-hero"},[_c('y-container',[_c('div',{staticClass:"c-privacy-hero__text-wrapper"},[_c('h1',{staticClass:"c-privacy-hero__title",domProps:{"innerHTML":_vm._s(_vm.textReplacer(_vm.title, 'hero-title-primary'))}}),_c('p',{staticClass:"c-privacy-hero__synopsis"},[_vm._v(" "+_vm._s(_vm.synopsis)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }